<template>
  <div class="more-box" :class="{ 'open': isOpen }"
    :style="{ 'max-height': maxHeight + 'px', 'padding-bottom': isShow == true ? '30px' : '0px' }">
    <slot></slot>
    <el-link type="primary" @click="open($event)" v-if="isShow" class="btn-more">查看更多&gt;&gt;</el-link>
  </div>
</template>


<script>
export default {
  data() {
    return {
      isOpen: false,
      isShow: false,
      default: 100,
      maxHeight: 90,
    }
  },
  mounted() {
    if (this.$el.clientHeight >= this.$el.scrollHeight) {
      this.isShow = false;
      this.isOpen = true;
    } else {
      this.isShow = true;
    }
  },
  methods: {
    open(e) {
      if (!this.isOpen) {
        this.isOpen = true;
        e.target.innerText = '收起更多>>';
      } else {
        this.isOpen = false;
        e.target.innerText = '查看更多>>';
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.more-box {
  position: relative;

  &.open {
    max-height: none !important;
  }

  .btn-more {
    position: absolute;
    display: block;
    bottom: -5px;
    cursor: pointer;
    width: 100%;
    line-height: 30px;
    text-align: center;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/moreInfo.vue